(function () {
  if (window.OpSections) return;

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var videoObservers = new WeakMap();
  var trackHandlers = new WeakMap();

  function activeTrack(section) {
    var tracks = section.querySelectorAll('[data-op-track]');
    for (var i = 0; i < tracks.length; i++) {
      if (tracks[i].offsetParent !== null) return tracks[i];
    }
    return tracks[0] || null;
  }

  function updateArrows(section) {
    var track = activeTrack(section);
    var prev = section.querySelector('[data-op-prev]');
    var next = section.querySelector('[data-op-next]');
    if (!track || (!prev && !next)) return;
    var maxScroll = track.scrollWidth - track.clientWidth;
    if (prev) prev.disabled = track.scrollLeft <= 1;
    if (next) next.disabled = maxScroll <= 1 || track.scrollLeft >= maxScroll - 1;
  }

  function updateDots(track) {
    var section = track.closest('.op-section');
    if (!section) return;
    var dots = section.querySelector('[data-op-dots]');
    if (!dots) return;
    var items = track.children;
    if (!items.length) return;
    var center = track.scrollLeft + track.clientWidth / 2;
    var closest = 0;
    var closestDist = Infinity;
    for (var i = 0; i < items.length; i++) {
      var mid = items[i].offsetLeft + items[i].offsetWidth / 2;
      var dist = Math.abs(mid - center);
      if (dist < closestDist) {
        closestDist = dist;
        closest = i;
      }
    }
    var dotEls = dots.children;
    for (var d = 0; d < dotEls.length; d++) {
      dotEls[d].classList.toggle('op-is-active', d === closest);
    }
  }

  function scrollByCards(track, dir) {
    var visibleWidth = track.clientWidth;
    var children = track.children;
    var delta = visibleWidth * dir;
    if (children.length) {
      var rect = children[0].getBoundingClientRect();
      var style = getComputedStyle(track);
      var gap = parseFloat(style.columnGap || style.gap || '0') || 0;
      var perView = Math.max(1, Math.floor((visibleWidth + gap) / (rect.width + gap)));
      delta = perView * (rect.width + gap) * dir;
    }
    track.scrollBy({ left: delta, behavior: reduceMotion ? 'auto' : 'smooth' });
  }

  function bindTrack(track) {
    if (trackHandlers.has(track)) return;
    var handler = function () {
      var section = track.closest('.op-section');
      if (section) updateArrows(section);
      updateDots(track);
    };
    track.addEventListener('scroll', handler, { passive: true });
    trackHandlers.set(track, handler);
    handler();
  }

  function initTracks(root) {
    var tracks = root.querySelectorAll('[data-op-track]');
    tracks.forEach(bindTrack);
    var sections = root.querySelectorAll('.op-section');
    sections.forEach(updateArrows);
  }

  function activateTab(tabs, activeTab) {
    var section = activeTab.closest('.op-section');
    tabs.forEach(function (tab) {
      var selected = tab === activeTab;
      tab.setAttribute('aria-selected', selected ? 'true' : 'false');
      tab.tabIndex = selected ? 0 : -1;
      var panel = document.getElementById(tab.getAttribute('aria-controls'));
      if (panel) panel.hidden = !selected;
    });
    var panel = document.getElementById(activeTab.getAttribute('aria-controls'));
    if (panel) {
      var track = panel.querySelector('[data-op-track]');
      if (track) track.scrollLeft = 0;
    }
    if (section) {
      var cta = section.querySelector('[data-op-shopall]');
      if (cta && cta.getAttribute('data-op-auto') === 'true' && activeTab.getAttribute('data-op-url')) {
        cta.setAttribute('href', activeTab.getAttribute('data-op-url'));
      }
      updateArrows(section);
    }
  }

  function tabKeydown(e) {
    var tab = e.currentTarget;
    var list = tab.closest('[role="tablist"]');
    if (!list) return;
    var tabs = Array.prototype.slice.call(list.querySelectorAll('[role="tab"]'));
    var idx = tabs.indexOf(tab);
    var next = null;
    if (e.key === 'ArrowRight') next = tabs[(idx + 1) % tabs.length];
    else if (e.key === 'ArrowLeft') next = tabs[(idx - 1 + tabs.length) % tabs.length];
    else if (e.key === 'Home') next = tabs[0];
    else if (e.key === 'End') next = tabs[tabs.length - 1];
    if (next) {
      e.preventDefault();
      next.focus();
      activateTab(tabs, next);
    }
  }

  function initTabs(root) {
    var lists = root.querySelectorAll('[role="tablist"][data-op-tabs]');
    lists.forEach(function (list) {
      var tabs = Array.prototype.slice.call(list.querySelectorAll('[role="tab"]'));
      tabs.forEach(function (tab) {
        if (tab.getAttribute('data-op-bound') === 'true') return;
        tab.setAttribute('data-op-bound', 'true');
        tab.addEventListener('click', function () {
          activateTab(tabs, tab);
        });
        tab.addEventListener('keydown', tabKeydown);
      });
    });
  }

  function loadVideo(video) {
    if (video.getAttribute('data-op-loaded') === 'true') return;
    var source = video.querySelector('source[data-src]');
    if (source) {
      source.setAttribute('src', source.getAttribute('data-src'));
      source.removeAttribute('data-src');
      video.load();
    }
    video.setAttribute('data-op-loaded', 'true');
    video.muted = true;
  }

  function initVideos(root) {
    var videos = root.querySelectorAll('video[data-op-lazy]');
    if (!videos.length || !window.IntersectionObserver) return;
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var video = entry.target;
          if (entry.isIntersecting) {
            if (reduceMotion) return;
            loadVideo(video);
            var playPromise = video.play();
            if (playPromise && playPromise.catch) playPromise.catch(function () {});
          } else {
            video.pause();
          }
        });
      },
      { rootMargin: '200px' }
    );
    videos.forEach(function (v) {
      io.observe(v);
    });
    videoObservers.set(root, io);
  }

  function addToCart(button) {
    if (button.getAttribute('data-op-adding') === 'true') return;
    button.setAttribute('data-op-adding', 'true');
    var id = button.getAttribute('data-op-variant');
    var panel = button.closest('[data-op-quickadd]');
    var msg = panel ? panel.querySelector('.op-card__qamsg') : null;
    if (panel) panel.setAttribute('aria-busy', 'true');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] }),
    })
      .then(function (res) {
        return res.json().then(function (data) {
          return { ok: res.ok, data: data };
        });
      })
      .then(function (result) {
        button.removeAttribute('data-op-adding');
        if (panel) panel.removeAttribute('aria-busy');
        if (result.ok) {
          document.dispatchEvent(
            new CustomEvent('ajaxProduct:added', { detail: { product: result.data, addToCartBtn: button } })
          );
        } else if (msg) {
          msg.textContent = (result.data && result.data.description) || 'Could not add to cart';
        }
      })
      .catch(function () {
        button.removeAttribute('data-op-adding');
        if (panel) panel.removeAttribute('aria-busy');
        if (msg) msg.textContent = 'Could not add to cart';
      });
  }

  function onDocumentClick(e) {
    var prevBtn = e.target.closest('[data-op-prev]');
    var nextBtn = e.target.closest('[data-op-next]');
    if (prevBtn || nextBtn) {
      e.stopImmediatePropagation();
      var section = (prevBtn || nextBtn).closest('.op-section');
      var track = section && activeTrack(section);
      if (track) scrollByCards(track, prevBtn ? -1 : 1);
      return;
    }
    var toggle = e.target.closest('[data-op-quickadd-toggle]');
    if (toggle) {
      e.stopImmediatePropagation();
      var card = toggle.closest('.op-card');
      var open = !card.classList.contains('op-is-quickadd-open');
      card.classList.toggle('op-is-quickadd-open', open);
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      return;
    }
    var sizeBtn = e.target.closest('.op-card__size');
    if (sizeBtn && !sizeBtn.disabled) {
      e.stopImmediatePropagation();
      addToCart(sizeBtn);
    }
  }

  function init(root) {
    root = root || document;
    initTracks(root);
    initTabs(root);
    initVideos(root);
  }

  function destroy(root) {
    if (!root || !root.querySelectorAll) return;
    var io = videoObservers.get(root);
    if (io) {
      io.disconnect();
      videoObservers.delete(root);
    }
    var videos = root.querySelectorAll('video');
    videos.forEach(function (v) {
      v.pause();
    });
  }

  document.addEventListener('click', onDocumentClick);

  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });
  document.addEventListener('shopify:section:unload', function (e) {
    destroy(e.target);
  });
  document.addEventListener('shopify:block:select', function (e) {
    var target = e.target;
    if (target.matches && target.matches('[role="tab"]')) {
      var list = target.closest('[role="tablist"]');
      if (list) {
        var tabs = Array.prototype.slice.call(list.querySelectorAll('[role="tab"]'));
        activateTab(tabs, target);
      }
    }
    if (target.closest && target.closest('[data-op-track]')) {
      target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', inline: 'center', block: 'nearest' });
    }
  });

  function boot() {
    init(document);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  window.OpSections = { init: init, destroy: destroy };
})();
